import http from "../../http-common";

const handle = (promise) =>
  promise
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });

// Catalogo (tipos de conta suportados + template types)
const getCatalog = async () => handle(http.get("/admin/messager/catalog"));

// Accounts
const accountsGetAll = async (params = {}) =>
  handle(http.get("/admin/messager/accounts", { params }));
const accountsGet = async (id) =>
  handle(http.get(`/admin/messager/accounts/${id}`));
const accountsCreate = async (data) =>
  handle(http.post("/admin/messager/accounts", data));
const accountsUpdate = async (id, data) =>
  handle(http.patch(`/admin/messager/accounts/${id}`, data));
const accountsDelete = async (id) =>
  handle(http.delete(`/admin/messager/accounts/${id}`));
const accountsSyncTemplates = async (id) =>
  handle(http.post(`/admin/messager/accounts/${id}/sync-templates`));
const accountsRegister = async (id, data) =>
  handle(http.post(`/admin/messager/accounts/${id}/register`, data));
const metaEmbeddedSignup = async (data) =>
  handle(http.post("/admin/messager/accounts/meta/embedded-signup", data));

// Templates
const templatesGetAll = async (params = {}) =>
  handle(http.get("/admin/messager/templates", { params }));
const templatesGet = async (id) =>
  handle(http.get(`/admin/messager/templates/${id}`));
const templatesCreate = async (data) =>
  handle(http.post("/admin/messager/templates", data));
const templatesUpdate = async (id, data) =>
  handle(http.patch(`/admin/messager/templates/${id}`, data));
const templatesSubmit = async (id) =>
  handle(http.post(`/admin/messager/templates/${id}/submit`));
const templatesSyncStatus = async (id) =>
  handle(http.post(`/admin/messager/templates/${id}/sync-status`));
const templatesDelete = async (id) =>
  handle(http.delete(`/admin/messager/templates/${id}`));

// Messages
const messagesGetAll = async (params = {}) =>
  handle(http.get("/admin/messager/messages", { params }));

export default {
  getCatalog,
  accounts: {
    getAll: accountsGetAll,
    get: accountsGet,
    create: accountsCreate,
    update: accountsUpdate,
    delete: accountsDelete,
    syncTemplates: accountsSyncTemplates,
    register: accountsRegister,
  },
  meta: {
    embeddedSignup: metaEmbeddedSignup,
  },
  templates: {
    getAll: templatesGetAll,
    get: templatesGet,
    create: templatesCreate,
    update: templatesUpdate,
    submit: templatesSubmit,
    syncStatus: templatesSyncStatus,
    delete: templatesDelete,
  },
  messages: {
    getAll: messagesGetAll,
  },
};
